var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanelSwitchClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .svg-switch-close{fill:#14355b}\n    ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        Close Panel\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-switch-close",
    d: "M17.5,1.9c0-0.3-0.1-0.5-0.3-0.7c-0.4-0.4-1.1-0.4-1.5,0L2.3,14.3c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1.1,0.4,1.5,0L17.2,2.6C17.4,2.4,17.5,2.1,17.5,1.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-switch-close",
    d: "M17.5,28.1c0-0.3-0.1-0.5-0.3-0.7L3.8,14.3c-0.4-0.4-1.1-0.4-1.5,0c-0.4,0.4-0.4,1,0,1.4l13.5,13.1c0.4,0.4,1.1,0.4,1.5,0C17.4,28.6,17.5,28.4,17.5,28.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-switch-close",
    d: "M28,1.9c0-0.3-0.1-0.5-0.3-0.7c-0.4-0.4-1.1-0.4-1.5,0L12.8,14.3c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1.1,0.4,1.5,0L27.7,2.6C27.9,2.4,28,2.1,28,1.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-switch-close",
    d: "M28,28.1c0-0.3-0.1-0.5-0.3-0.7L14.2,14.3c-0.4-0.4-1.1-0.4-1.5,0c-0.4,0.4-0.4,1,0,1.4l13.5,13.1c0.4,0.4,1.1,0.4,1.5,0C27.9,28.6,28,28.4,28,28.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelSwitchClose);
export default __webpack_public_path__ + "static/media/panel-switch-close.2490f836e4889b2019f10773545a2317.svg";
export { ForwardRef as ReactComponent };